import { localDateString } from "./timezones";

const PAST_CACHE = { staleTime: Infinity, gcTime: Infinity } as const;
const CURRENT_CACHE = { staleTime: 10_000, gcTime: 5 * 60_000 } as const;

export type ReportPeriod = "daily" | "weekly" | "monthly" | "quarterly" | "yearly";

export function reportCacheConfig(
  period: ReportPeriod,
  dateStr: string,
  tz: string = "UTC",
): { staleTime: number; gcTime: number } {
  const today = localDateString(new Date(), tz);
  let isPast: boolean;
  switch (period) {
    case "monthly":
      isPast = dateStr < today.slice(0, 7);
      break;
    case "quarterly": {
      const currentQuarter = Math.floor((Number(today.slice(5, 7)) - 1) / 3) + 1;
      isPast = dateStr < `${today.slice(0, 4)}-Q${currentQuarter}`;
      break;
    }
    case "yearly":
      isPast = dateStr < today.slice(0, 4);
      break;
    default:
      isPast = dateStr < today;
  }
  return isPast ? PAST_CACHE : CURRENT_CACHE;
}
